import {EmailData} from './EmailData'

export type VerifyUserEmailData = EmailData & {
    verificationCode: string
}
